import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withTheme } from 'styled-components';
import moment from 'moment'
import lo from 'lodash'
import { withRouter } from 'react-router-dom';

import { ButtonReg } from 'atoms/Buttons'
import Icon from 'atoms/Icon';
import IconPng from 'atoms/IconPng';
import { FormTxt } from 'atoms/Inputs'
import { Label } from 'atoms/Texts';
import Breadcrumb from 'molecules/Breadcrumb';
import DataTable from 'organisms/DataTable';
import { BARGE_CHECKLIST, CHECKLIST } from 'fixtures/api';
import { setLocalSettingsTableData } from 'Redux/actions/SettingsTableActions';
import { getAllList } from 'services/cmsService';
import { Button, EmptyWrapper, FilterCol, Filters, PageWrapper, RoundedWrapper, StyledDatePicker, TableWrapper } from './styles'

const ic_eye = require('App/assets/images/ic_eye.png')
const ic_folder = require('App/assets/images/ic_folder.png')

class List extends Component {
  constructor(props) {
    super(props)
    this.state = {
      navList: [
        'Report',
        'Report Barge Checklist',
      ],
      filters: {
        date: null,
        search: ''
      },
      data: [],
    }
  }

  inputConfig = {
    border: this.props.theme.mocaGrey,
    yxPadding: '9px 12px',
    height: '34px',
    mb: 0
  }

  onFilterChange = (field, val) => {
    const { filters } = this.state
    filters[field] = val
    this.setState({ filters })
  }

  onView = async () => {
    const { filters: { date, search } } = this.state
    const params = new URLSearchParams()
    params.set('type', BARGE_CHECKLIST)
    params.set('sortBy', 'date')
    params.set('sortDir', 'desc')
    if (date) params.set('date', moment(date).utc(true).format())
    if (search) params.set('search', search)
    const data = await getAllList(`${CHECKLIST}?${params.toString()}`)
    this.setState({
      data: data || []
    })
  }

  onSizePerPageChange = (size) => {
    const { setLocalSettingsTableData, settingsTable } = this.props
    const { navList } = this.state
    const settings = lo.cloneDeep(settingsTable)
    settings.sizePerPage[navList[1]] = size
    setLocalSettingsTableData(settings)
  }

  render() {
    const { viewState: { isLoading, isMobileView }, settingsTable, match: { path }, history: { push } } = this.props
    const { navList, filters, data } = this.state;
    const sizePerPage = settingsTable.sizePerPage[navList[1]]

    const columnConfig = [
      {
        dataField: 'date',
        text: 'Date',
        formatter: (cell, row) => moment(row.date).format('DD-MMMM-YYYY'),
        sort: true
      },
      {
        dataField: 'tugboatName',
        text: 'Tugboat Name',
        sort: true
      },
      {
        dataField: 'motherVessel',
        text: 'Mother Vessel',
        sort: true
      },
      {
        dataField: 'action',
        text: 'Action',
        sort: false,
        headerAttrs: { width: 150 },
        headerAlign: 'center',
        align: 'center',
        formatter: (cell, row) => (
          <ButtonReg
            width={'28px'}
            height={'28px'}
            className={'ml-2'}
            onClick={() => push(`${path}${row.id}`)}
            btnTxt={
              <Icon
                ml="auto"
                name="table"
                color="#FFF"
                showPointer
              />
            }
          />
        ),
        isDummyField: true
      }
    ]

    return (
      <PageWrapper isMobile={isMobileView}>
        <Breadcrumb navList={navList} />
        {!isLoading &&
          <RoundedWrapper>
            <Filters>
              <FilterCol>
                <Label lineheight={'14px'} size={'12px'}>
                  Date
                </Label>
                <StyledDatePicker
                  onChange={date => this.onFilterChange('date', date)}
                  value={filters.date}
                />
              </FilterCol>
              <FilterCol>
                <Label lineheight={'14px'} size={'12px'}>
                  Search
                </Label>
                <FormTxt
                  placeholder={'Search tugboat name or mother vessel...'}
                  mb={'16px'}
                  value={filters.search}
                  onChangeVal={e => this.onFilterChange('search', e.target.value)}
                  {...this.inputConfig}
                />
              </FilterCol>
              <Button
                btnTxt={
                  <IconPng srcIcon={ic_eye} ml={'0'} mb={'3px'} size={'auto'} h={'13'} showPointer={true} />
                }
                rad={'6px'}
                onClick={this.onView}
                width={'34px'}
                height={'34px'}
              />
            </Filters>


            {!data &&
              <EmptyWrapper className="text-center">
                <div>
                  <IconPng srcIcon={ic_folder} size={'auto'} h={'86'} mb={'20px'} />
                </div>
                <Label weight={'600'} lineheight={'14px'} mb={'35px'} size={'12px'}>
                  Select filters and click "Edit” button to start
                </Label>
              </EmptyWrapper>
            }

            <TableWrapper>
              <DataTable
                minWidth={'700px'}
                dataList={data}
                columnConfig={columnConfig}
                sizePerPage={sizePerPage}
                onSizePerPageChange={this.onSizePerPageChange}
              />
            </TableWrapper>
          </RoundedWrapper>
        }
      </PageWrapper>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    viewState: state.viewState,
    settingsTable: state.settingsTable
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setLocalSettingsTableData
    },
    dispatch
  )

export default withRouter(
  withTheme(
    connect(mapStateToProps, mapDispatchToProps)(List)
  )
)
